export const INVALID_DATE: string = "Invalid Date";
export const MAX_INPUT_SYMBOLS_COUNT = 300;